import React, { useState, useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap } from '@fortawesome/pro-light-svg-icons';
import { setCourseId } from '../../../store/courseSlice';
import { FormTextField } from '../../common/Form/FormTextField';
import { SIDEKICK_DASHBOARD_PATH } from '../../common/constants';
import MssModal from '../../common/MssModal';

function CourseDialog({ open, onClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxCourseId = useSelector((state) => state.course.courseId);
  const [localCourseId, setLocalCourseId] = useState('');

  useEffect(() => {
    if (open) setLocalCourseId(reduxCourseId ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleApply = () => {
    const isSwitchingCourse = !!reduxCourseId && localCourseId !== reduxCourseId;
    dispatch(setCourseId(localCourseId));
    onClose();
    if (isSwitchingCourse) {
      navigate(SIDEKICK_DASHBOARD_PATH);
    }
  };

  return (
    <MssModal
      isOpen={open}
      onClose={onClose}
      isCloseable
      noHeader
      maxWidth="xs"
      id="courseDialog"
      primaryButtonTitle={reduxCourseId ? 'Switch Course' : 'Set Course'}
      onPrimaryClick={handleApply}
      isPrimaryButtonDisabled={!localCourseId}
    >
      <Stack direction="row" sx={{ mb: 2 }}>
        <FontAwesomeIcon icon={faGraduationCap} fixedWidth size="lg" />
        <Typography component="h2">Course</Typography>
      </Stack>

      <Stack direction="row">
        <Typography component="label" sx={{ mt: 1, mr: 1, whiteSpace: 'nowrap' }}>
          Course ID
        </Typography>
        <Box sx={{ width: '100%' }}>
          <FormTextField
            id="courseDialog__courseId"
            ariaLabel="Course ID"
            placeholder="Course ID"
            value={localCourseId}
            onChange={(e) => setLocalCourseId(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && localCourseId) {
                e.preventDefault();
                handleApply();
              }
            }}
            variant="outlined"
            size="small"
            fullWidth
          />
        </Box>
      </Stack>
    </MssModal>
  );
}

export default CourseDialog;
